<template>
  <v-flex
    ref="toc"
    v-view="handleScroll"
    class="toc"
  >
    <slot name="backButton" />
    <a
      v-if="$vuetify.breakpoint.xsOnly"
      class="close-btn"
      @click="closeDialog"
    >
      <v-icon>clear</v-icon>
    </a>
    <ul
      v-for="(elements, index) in TOCData"
      :key="index"
    >
      <li
        v-for="(item, index) in elements"
        :key="index"
      >
        <p
          v-if="item.header"
          :class="{ 'sz_medium_grey--text': !isCurrentList(elements) }"
        >
          <v-btn
            class="button-height"
            fab
            dark
            color="sz_red"
            :class="{ 'active sz_medium_grey--text': !isCurrentList(elements) }"
          >
            <span>{{ item.number }}</span>
          </v-btn>
          {{ item.header }}
        </p>
        <a
          v-else-if="isCurrentList(elements)"
          :class="{ active: getCurrentSelectorName === item.selector }"
          @click="goToById(item.selector)"
        >{{ item.name }}</a>
      </li>
    </ul>
  </v-flex>
</template>

<script>
export default {
    name: 'TableOfContent',
    props: {
        TOCData: {
            required: true,
            type: Array
        }
    },
    data () {
        return {
            scrollOptions: { duration: 300, offset: 18, easing: 'easeInOutCubic' },
            fixedToCPosition: 0
        };
    },
    computed: {
        currentRouteName () {
            return this.$route.name;
        },
        getCurrentSelectorName () {
            return this.$store.getters['warehouses/getCurrentSelectorName'];
        }
    },
    mounted () {
        this.fixedToCPosition = this.$refs.toc.offsetTop - 15;
    },
    methods: {
        handleScroll (e) {
            if (window.pageYOffset >= this.fixedToCPosition) {
                e.target.element.classList.add('stick-to-top');
            } else {
                e.target.element.classList.remove('stick-to-top');
            }
        },
        closeDialog () {
            this.$emit('closeDialog');
        },
        isCurrentList (element) {
            const _item = element.find((el) => {
                return el.header;
            });
            return _item.name === this.currentRouteName;
        },
        goToById (id) {
            this.$vuetify.goTo('#' + id, this.scrollOptions);
            if (this.$vuetify.breakpoint.xsOnly) {
                this.closeDialog();
            }
        }
    }
};
</script>

<style scoped></style>
